import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {DataService} from '../../../../Services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterPipe} from 'ngx-filter-pipe';
import {DatePipe, DecimalPipe} from '@angular/common';
import {AppConfigService} from '../../../../Services/app-config.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {RoutingTrackerService} from '../../../../Services/routing-tracker.service';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {DataExportService} from '../../../../Services/dataExport.service';
import {firstValueFrom} from 'rxjs';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-entity-reconciliation',
  templateUrl: './entity-reconciliation.component.html',
  styleUrls: ['./entity-reconciliation.component.css'],
  standalone: false
})
export class EntityReconciliationComponent implements OnInit, AfterViewInit, AfterViewChecked {

  // Email modal integration
  reportDataToSendInEmail: EmailModel = new EmailModel();

  private rptName: string;

  // Standard header button configuration
  buttonConfig: any = {
    reportFormat: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };

  public vm: any = {
    report: [],
    buttonsDisabled: false,
    showSpecificDates: false,
    request: {
      toDate: '',
      fromDate: '',
      entity_id: null,
      entity_type_id: null,
      company_id: null,
      currency_id: null,
      includeUnposted: false,
    },
    totalOwing: null,
    totalCurrent: null,
    total1to30: null,
    total31to60: null,
    total61to90: null,
    total91plus: null,
    subLedger: null,
    payment: {
      total: null,
    },
    startEntityName: null,
    entity: [],
    entityInput: '',
    entity_email: '',
    email: {
      toemail: null,
      fromemail: this.appConfig.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    currency: [],
    company: [],
    entityName: [],
    entity_type: [],
    i: {
      details: [],
    },
    invoicesTotal: null,
    p: {
      details: [],
    },
    payments: [],
    invoices: [],
    startEntity: 0,
    entityFilter: {
      name: null,
    },
    fromDateSelect: [],
    toDateSelect: [],
    monthCount: [],
    entityError: null,
    paymentsTotal: 0,
    showEmail: true,
  };

  public urlParams: any = [];
  public reportHasRun = false;
  routedFrom = '';

  constructor(
    private titleService: Title,
    public dateFilter: DateFilterService,
    public tableDataService: DataService,
    public notification: BsToastService,
    private route: ActivatedRoute,
    private router: Router,
    public appConfig: AppConfigService,
    public datePipe: DatePipe,
    public prevUrl: RoutingTrackerService,
    public excelExporter: DataExportService,
    private reportPrint: ReportPrintService
  ) {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined) {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }

  ngOnInit() {
    this.vm.subLedger = this.route.snapshot.paramMap.get('subLedger');
    this.urlParams = this.route.snapshot.queryParams;

    if (this.urlParams.entity_id) {
      this.vm.request.entity_id = this.urlParams.entity_id;
    }

    this.FilterOptionsInit().then();
    // this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);
    this.rptName =
      this.vm.subLedger.toUpperCase() +
      ' ' +
      $localize`:Entity Reconciliation @@entityReconciliation:Entity Reconciliation`;
    // console.log('from:' + this.vm.request.fromDate + ' ' + 'to:' + this.vm.request.toDate);
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;
    const reportName = 'Entity Reconciliation';

    // printing options
    emailDocObj.print_orientation = '2';
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Build unified HTML for email and print
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch (e) {
      emailDocObj.pdfHtml = '';
    }

    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = 'Entity_Reconciliation_' + yyyy + mm + dd + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;

    // Open the shared Send Email modal on next tick to let bindings settle
    setTimeout(() => {
      const element = document.getElementById('sendEmailModal') as HTMLElement;
      if (element) {
        const emailModal = new Modal(element);
        emailModal.show();
      }
    }, 0);
  }

  // Print via hidden iframe using the same HTML used for email
  printReport() {
    try {
      const html = this.buildPrintHtml(false);
      this.printHtmlInIframe(html);
    } catch (e) {
      // noop
    }
  }

  exportToExcel() {
    try {
      this.excelExporter.exportHtmlToExcel(this.buildExportHtml(), 'Entity Reconciliation.xlsx');
    } catch (e) {
      // noop
    }
  }

  ngAfterViewChecked() {
    // Legacy email pass-through removed in favor of SendEmailModalComponent
  }

  // Build export HTML from data (no DOM dependency)
  private buildExportHtml(): string {
    const fmt = (v: number) => new DecimalPipe('en-US').transform(Math.abs(v), '1.2-2') || '0.00';
    const cell = (v: number) => v >= 0 ? fmt(v) : `(${fmt(v)})`;
    const thStyle = 'border-bottom:2px solid #ddd;padding:4px;';
    const dateStr = (d: any) => d ? new Date(d).toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'}) : '';
    const invRows = (this.vm.invoices || []).map((i: any) => {
      const detailRows = (i.details || []).filter((d: any) => d.control_line !== '1').map((d: any) =>
        `<tr><td style="padding-left:20px;border-bottom:1px solid #ddd;padding:4px">${d.applied_amount >= 0 ? 'Invoice' : 'Credit'}: ${d.number || ''} ${d.description || ''}</td><td style="text-align:center;border-bottom:1px solid #ddd;padding:4px">${dateStr(d.header_date)}</td><td style="text-align:right;border-bottom:1px solid #ddd;padding:4px">${cell(d.applied_amount)}</td><td></td></tr>`
      ).join('');
      return `<tr><td style="border-bottom:1px solid #ddd;padding:4px"><strong>${i.amount >= 0 ? 'Invoice' : 'Credit'}: ${i.number || ''}</strong>${i.entity_name ? ' &bull; ' + i.entity_name : ''}${i.description ? ' &bull; ' + i.description : ''}</td><td style="text-align:center;border-bottom:1px solid #ddd;padding:4px">${dateStr(i.header_date)}</td><td style="text-align:right;border-bottom:1px solid #ddd;padding:4px">${cell(i.amount)}</td><td style="text-align:right;border-bottom:1px solid #ddd;padding:4px">${cell(i.owing)}</td></tr>${detailRows}`;
    }).join('');
    const invTable = `<table style="border-collapse:collapse;width:100%"><thead><tr>
      <th style="${thStyle}text-align:left">Invoice &amp; (Credits)</th>
      <th style="${thStyle}text-align:center">Date</th>
      <th style="${thStyle}text-align:right">Invoice (Credit)</th>
      <th style="${thStyle}text-align:right">Balance</th>
    </tr></thead><tbody>${invRows}</tbody><tfoot><tr>
      <th colspan="2" style="${thStyle}text-align:left">Invoices Total</th>
      <th style="${thStyle}text-align:right">${cell(this.vm.invoicesTotal || 0)}</th>
      <th style="${thStyle}"><small>Count: ${(this.vm.invoices || []).length}</small></th>
    </tr></tfoot></table>`;
    const payRows = (this.vm.payments || []).map((p: any) => {
      const detailRows = (p.details || []).filter((d: any) => d.control_line !== '1').map((d: any) =>
        `<tr><td style="padding-left:20px;border-bottom:1px solid #ddd;padding:4px">${d.applied_amount >= 0 ? 'Invoice' : 'Credit'}: ${d.number || ''} ${d.description || ''}</td><td style="text-align:center;border-bottom:1px solid #ddd;padding:4px">${dateStr(d.header_date)}</td><td style="text-align:right;border-bottom:1px solid #ddd;padding:4px">${cell(d.applied_amount)}</td><td></td></tr>`
      ).join('');
      return `<tr><td style="border-bottom:1px solid #ddd;padding:4px"><strong>${p.amount >= 0 ? 'Payment' : 'Refund'}: ${p.number || ''}</strong>${p.entity_name ? ' &bull; ' + p.entity_name : ''}${p.description ? ' &bull; ' + p.description : ''}</td><td style="text-align:center;border-bottom:1px solid #ddd;padding:4px">${dateStr(p.header_date)}</td><td style="text-align:right;border-bottom:1px solid #ddd;padding:4px">${cell(p.amount)}</td><td style="text-align:right;border-bottom:1px solid #ddd;padding:4px">${p.unapplied !== 0 ? cell(p.unapplied) : ''}</td></tr>${detailRows}`;
    }).join('');
    const payTable = `<table style="border-collapse:collapse;width:100%"><thead><tr>
      <th style="${thStyle}text-align:left">Payments &amp; (Refunds)</th>
      <th style="${thStyle}text-align:center">Date</th>
      <th style="${thStyle}text-align:right">Payment (Refund)</th>
      <th style="${thStyle}text-align:right">Unapplied</th>
    </tr></thead><tbody>${payRows}</tbody><tfoot><tr>
      <th colspan="2" style="${thStyle}text-align:left">Payments Total</th>
      <th style="${thStyle}text-align:right">${cell(this.vm.paymentsTotal || 0)}</th>
      <th style="${thStyle}"><small>Count: ${(this.vm.payments || []).length}</small></th>
    </tr></tfoot></table>`;
    return `<table width="100%"><tr><td style="width:50%;vertical-align:top;padding-right:12px">${invTable}</td><td style="width:50%;vertical-align:top;padding-left:12px">${payTable}</td></tr></table>`;
  }

  // Build a self-contained HTML document for printing/emailing
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = this.buildExportHtml();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: from && to ? `${from} to ${to}` : (from || to)});
    }
    return this.reportPrint.buildHtml({title: 'Entity Reconciliation', contentHtml: content, meta, orientation: 'landscape'});
  }

  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  private escapeHtml(value: any): string {
    const s = value == null ? '' : String(value);
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async FilterOptionsInit() {
    this.tableDataService
      .getData('currency?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.currency = result.Data;
      });
    this.tableDataService
      .getData('company?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
      });

    this.tableDataService
      .getData('entity_type?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.entity_type = result.Data;
      });

    this.vm.entity = await this.getFilterValues('entity', '?state=active');
    for (const [x, value] of Object.entries(this.vm.entity)) {
      this.vm.entityName.push({ name: this.vm.entity[x].name });
    }

    if (this.urlParams.entity_id != null || this.urlParams.entity_id != undefined) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        // console.log('outside if:' + this.vm.entity[y].id);
        if (this.vm.entity[y]) {
          // console.log('inside if:' + this.vm.entity[y].id);
          if (this.vm.entity[y].id == this.urlParams.entity_id) {
            this.vm.entityInput = this.vm.entity[y].name;
            this.vm.request.entity_id = this.vm.entity[y].id;
            this.vm.request.entity_email = this.vm.entity[y].email;
            // console.log('break:' + this.vm.entityInput);
            break;
          }
        }
      }
    }

    const hasUrlDates = !!(this.urlParams.fromDate || this.urlParams.toDate);
    if (this.urlParams.fromDate) {
      this.vm.request.fromDate = this.urlParams.fromDate;
      this.vm.showSpecificDates = true;
    }

    if (this.urlParams.toDate) {
      this.vm.request.toDate = this.urlParams.toDate;
      this.vm.showSpecificDates = true;
    }

    if (!this.vm.request.toDate && !this.vm.request.fromDate) {
      this.newDateFilter(new Date(), new Date());
      const range = this.dateFilter.GetDefaultDateRange('span', this.vm.fromDateSelect, this.vm.toDateSelect);
      this.vm.request.toDate = range.toDate;
      this.vm.request.fromDate = range.fromDate;
    }

    this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);

    if (hasUrlDates && this.vm.request.toDate && this.vm.request.fromDate && this.vm.request.entity_id) {
      this.update();
    }
  }

  async getFilterValues(tablename, param) {
    // let values = '';
    // values = this.localStorage.StorageGet(tablename, '');
    // if (values == '' || !this.IsValidJSONString(values)) {
    const result = await firstValueFrom(this.tableDataService
      .getData(tablename + param + '&pageNumber=0&pageSize=99999'));
    const values = result.Data;
    // this.localStorage.StorageSet(tablename, JSON.stringify(values));
    // } else {
    // values = JSON.parse(values);
    // }
    return values;
  }

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  update() {
    this.vm.entityError = false;
    this.vm.invoices = [];
    if (!this.vm.request.entity_id) {
      this.vm.entityError = true;
      this.notification.showWarningToast($localize`:Entity is required. @@entityisrequired:Entity is required.`);
    } else {
      this.vm.buttonsDisabled = true;
      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);
      const urlParamsJson = {
        fromDate: this.vm.request.fromDate,
        toDate: this.vm.request.toDate,
        entity_id: this.vm.request.entity_id,
        entity_type_id: this.vm.request.entity_type_id,
        company_id: this.vm.request.company_id,
        currency_id: this.vm.request.currency_id,
      };
      // console.log(JSON.stringify(urlParamsJson));
      const urlParams: string = this.encodeQueryData(urlParamsJson);
      // console.log(urlParams);
      this.tableDataService.getData('EntityReconciliationPayments', '?' + urlParams).subscribe((result) => {
        this.vm.payments = result;
        // app report buttons rely on report object - this report was created using th above object
        this.vm.report = result;
        this.reportHasRun = true;
        this.paymentTotal();
        // this.localStorage.StorageSet('toDate', this.vm.request.toDate);
        // this.localStorage.StorageSet('fromDate', this.vm.request.fromDate);
        const urlParamsJson2 = {
          toDate: this.vm.request.toDate,
          fromDate: this.vm.request.fromDate,
          subLedger: this.vm.subLedger,
          entity_id: this.vm.request.entity_id,
          entity_type_id: this.vm.request.entity_type_id,
          company_id: this.vm.request.company_id,
          currency_id: this.vm.request.currency_id,
        };
        const urlParams2: string = this.encodeQueryData(urlParamsJson2);
        this.tableDataService.getData('EntityReconciliationInvoices', '?' + urlParams2).subscribe((result2) => {
          this.vm.invoices = result2;
          this.invoiceTotal();
          // Enable buttons if either payments or invoices returned data
          this.vm.report = (this.vm.payments?.length > 0 || this.vm.invoices?.length > 0)
            ? [{one: 'record'}]
            : [];
          this.vm.buttonsDisabled = false;
          this.reportHasRun = true;
        });
        this.calcTotals();
        this.reportHasRun = true;
      });
    }
  }

  invoiceTotal() {
    this.vm.invoices.forEach((inv_detail) => {
      this.vm.invoicesTotal = this.vm.invoicesTotal + inv_detail.detail_total;
    });
  }

  paymentTotal() {
    this.vm.payments.forEach((item) => {
      this.vm.paymentsTotal = this.vm.paymentsTotal + item.detail_total;
    });
  }

  calcTotals() {
    this.vm.invoicesTotal = 0;

    // for (const [x, value] of Object.entries(this.vm.invoices)) {
    //   this.vm.invoicesTotal += Number(this.vm.invoices[x].amount);
    // }
    // this.vm.paymentsTotal = 0;
    // for (const [x, value] of Object.entries(this.vm.payments)) {
    //   this.vm.paymentsTotal += Number(this.vm.payments[x].amount);
    // }
    if (this.vm.payments.length > 0 || this.vm.invoices.length > 0) {
      this.vm.report = [{ one: 'record' }];
    } else {
      this.vm.report = [];
    }
  }

  handleDateChange() {
    this.vm.report = [];
    this.vm.payments = [];
    this.vm.invoices = [];
    this.vm.paymentsTotal = 0;
    this.vm.invoicesTotal = 0;
    this.vm.totalOwing = null;
    this.vm.totalCurrent = null;
    this.vm.total1to30 = null;
    this.vm.total31to60 = null;
    this.vm.total61to90 = null;
    this.vm.total91plus = null;
    this.reportHasRun = false;
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  selectEntityModal(entityName) {
    this.vm.request.entity_id = '';
    if (this.vm.request.entity_id == '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        if (this.vm.entity[y].name == entityName) {
          this.vm.entityInput = entityName;
          this.vm.request.entity_id = this.vm.entity[y].id;
          this.vm.entity_email = this.vm.entity[y].email;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  testEntity() {
    const entityIdStart = this.vm.request.entity_id;
    if (!this.vm.entityInput || this.vm.entityInput == '' || this.vm.entityInput == null) {
      this.vm.request.entity_id = '';
    } else {
      if (this.FilterObject(this.vm.entity, { name: this.vm.entityInput }).length > 0) {
        const entityId = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].id;
        const entityName = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].name;
        const entityEmail = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].email;
        if (entityId != '' || entityId != null) {
          this.vm.request.entity_id = entityId;
          this.vm.entityInput = entityName;
          this.vm.entity_email = entityEmail;
        } else {
          this.vm.request.entity_id = '';
          this.vm.entity_email = '';
        }
      } else {
        this.vm.request.entity_id = '';
        this.vm.entity_email = '';
      }
    }
    if (entityIdStart != this.vm.request.entity_id) {
      this.vm.report = [];
    }
  }

  updateEntity() {
    this.vm.buttonsDisabled = true;
    this.tableDataService
      .getData('entity', '?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.entity = result.Data;
        this.vm.buttonsDisabled = false;
      });
  }

  close() {
    if (this.routedFrom) {
      this.router.navigateByUrl(this.routedFrom).then();
    } else if (this.routedFrom === '' || this.routedFrom == undefined) {
      window.close();
    } else {
      this.router.navigateByUrl('/home').then();
    }
  }

  clear() {
    this.vm.request = {
      toDate: null,
      fromDate: null,
      includeUnposted: false,
      entity_id: null,
      entity_type_id: null,
      company_id: null,
      currency_id: null,
    };
    this.vm.report = [];
    this.vm.entityInput = '';
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }
}
